// extracted by extract-css-chunks-webpack-plugin
module.exports = {"header_wp":"header_wp-f_V1WhAc","header":"header-3zals5Dt","linkList":"linkList-2wnYw5-F","home":"home-3q4286uB"};